import React from "react";
import { ShuffleCreateLoaderTemplate } from "themes/administration/shuffle/components";

function ShuffleCreateLoader(props) {
    return <ShuffleCreateLoaderTemplate {...props} />;
}

export default ShuffleCreateLoader;
